// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/portfolio.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddMarketObservationRequest, AddMarketObservationResponse, AppendLandscapeHypothesisRequest, AppendLandscapeHypothesisResponse, AssociateLandscapeIntelligenceRequest, AssociateLandscapeIntelligenceResponse, CreateOpportunityLotRequest, CreateOpportunityLotResponse, ExportLandscapeReportRequest, ExportLandscapeReportResponse, GenerateLandscapeReportRequest, GenerateLandscapeReportResponse, GetLandscapeComparisonRequest, GetLandscapeComparisonResponse, GetLandscapeHypothesesRequest, GetLandscapeHypothesesResponse, GetLandscapeReportRequest, GetLandscapeReportResponse, GetLandscapeSynthesisRequest, GetLandscapeSynthesisResponse, GetPortfolioEconomicsRequest, GetPortfolioEconomicsResponse, ListLandscapeIntelligenceRequest, ListLandscapeIntelligenceResponse, ListLandscapeReportsRequest, ListLandscapeReportsResponse, RetainLandscapeObservationRequest, RetainLandscapeObservationResponse, SaveLandscapeReportPresentationRequest, SaveLandscapeReportPresentationResponse, SetOpportunityValueRequest, SetOpportunityValueResponse } from "./portfolio_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * PortfolioService is the browser edge for canonical portfolio economics
 * (SAD-555 LAND-09, GP-16). Home, the Landscapes list, a Landscape's detail
 * and the CSV export all read GetPortfolioEconomics — no client-side summing.
 *
 * Reads need the Cerbos "opportunity" read action at the tenant root and writes
 * the matching write action; a denied caller gets PermissionDenied, never
 * partial totals. Pursuit and Proposal counts include only projects the caller
 * can see; the tenant and caller come from the session.
 *
 * @generated from service mono.projectdata.v1.PortfolioService
 */ export const PortfolioService = {
    typeName: "mono.projectdata.v1.PortfolioService",
    methods: {
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.GetPortfolioEconomics
     */ getPortfolioEconomics: {
            name: "GetPortfolioEconomics",
            I: GetPortfolioEconomicsRequest,
            O: GetPortfolioEconomicsResponse,
            kind: MethodKind.Unary
        },
        /**
     * SetOpportunityValue upserts the value for (opportunity, lot, kind).
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.SetOpportunityValue
     */ setOpportunityValue: {
            name: "SetOpportunityValue",
            I: SetOpportunityValueRequest,
            O: SetOpportunityValueResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateOpportunityLot is idempotent on the lot label.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.CreateOpportunityLot
     */ createOpportunityLot: {
            name: "CreateOpportunityLot",
            I: CreateOpportunityLotRequest,
            O: CreateOpportunityLotResponse,
            kind: MethodKind.Unary
        },
        /**
     * LAND-03: current figures use GetPortfolioEconomics; sources use its effective rows.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.GetLandscapeComparison
     */ getLandscapeComparison: {
            name: "GetLandscapeComparison",
            I: GetLandscapeComparisonRequest,
            O: GetLandscapeComparisonResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.AddMarketObservation
     */ addMarketObservation: {
            name: "AddMarketObservation",
            I: AddMarketObservationRequest,
            O: AddMarketObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.GetLandscapeHypotheses
     */ getLandscapeHypotheses: {
            name: "GetLandscapeHypotheses",
            I: GetLandscapeHypothesesRequest,
            O: GetLandscapeHypothesesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.AppendLandscapeHypothesis
     */ appendLandscapeHypothesis: {
            name: "AppendLandscapeHypothesis",
            I: AppendLandscapeHypothesisRequest,
            O: AppendLandscapeHypothesisResponse,
            kind: MethodKind.Unary
        },
        /**
     * Audience reads need no Growth/raw-source authority. Associations grant none.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.ListLandscapeIntelligence
     */ listLandscapeIntelligence: {
            name: "ListLandscapeIntelligence",
            I: ListLandscapeIntelligenceRequest,
            O: ListLandscapeIntelligenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.AssociateLandscapeIntelligence
     */ associateLandscapeIntelligence: {
            name: "AssociateLandscapeIntelligence",
            I: AssociateLandscapeIntelligenceRequest,
            O: AssociateLandscapeIntelligenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * LAND-08: reviewable AI synthesis over only the evidence the caller may read
     * (same gate and rows as GetLandscapeComparison). Persists nothing but an
     * audit record of the provider input; totals are never model-generated.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.GetLandscapeSynthesis
     */ getLandscapeSynthesis: {
            name: "GetLandscapeSynthesis",
            I: GetLandscapeSynthesisRequest,
            O: GetLandscapeSynthesisResponse,
            kind: MethodKind.Unary
        },
        /**
     * LAND-08: stores an Accepted retain_observation proposal. The only write.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.RetainLandscapeObservation
     */ retainLandscapeObservation: {
            name: "RetainLandscapeObservation",
            I: RetainLandscapeObservationRequest,
            O: RetainLandscapeObservationResponse,
            kind: MethodKind.Unary
        },
        /**
     * SAD-540 (LAND-07): persisted, immutable, versioned Landscape reports.
     * Generation reuses GetPortfolioEconomics's own canonical projection —
     * there is no separate reporting calculator.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.GenerateLandscapeReport
     */ generateLandscapeReport: {
            name: "GenerateLandscapeReport",
            I: GenerateLandscapeReportRequest,
            O: GenerateLandscapeReportResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.ListLandscapeReports
     */ listLandscapeReports: {
            name: "ListLandscapeReports",
            I: ListLandscapeReportsRequest,
            O: ListLandscapeReportsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.projectdata.v1.PortfolioService.GetLandscapeReport
     */ getLandscapeReport: {
            name: "GetLandscapeReport",
            I: GetLandscapeReportRequest,
            O: GetLandscapeReportResponse,
            kind: MethodKind.Unary
        },
        /**
     * Presentation edits (headline/note) never touch a version's frozen content.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.SaveLandscapeReportPresentation
     */ saveLandscapeReportPresentation: {
            name: "SaveLandscapeReportPresentation",
            I: SaveLandscapeReportPresentationRequest,
            O: SaveLandscapeReportPresentationResponse,
            kind: MethodKind.Unary
        },
        /**
     * Rendered in zou from the persisted version; never recomputed.
     *
     * @generated from rpc mono.projectdata.v1.PortfolioService.ExportLandscapeReport
     */ exportLandscapeReport: {
            name: "ExportLandscapeReport",
            I: ExportLandscapeReportRequest,
            O: ExportLandscapeReportResponse,
            kind: MethodKind.Unary
        }
    }
};
